import { Box, Button, Paper, TextField, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Card, FormControl, FormHelperText } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useAddOuvidoriaRespostaMutation, useGetOuvidoriaByLoginMutation, useGetOuvidoriaQuery, useGetOuvidoriasHistoricosQuery } from '../ouvidoriaApiSlice';
import { ISouvidoria, ISouvidoriaList, OuvidoriaHistoricoAddDTO, OuvidoriaHistoricoList, OuvidoriaList, OuvidoriaRespostaDTO } from '../types/Ouvidoria';
import { Iso } from '@mui/icons-material';
import { OuvidoriaAnexo } from '../types/OuvidoriaAnexo';
import { useAddOuvidoriaAnexosRespostaMutation, useGetOuvidoriaAnexosQuery, useGetOuvidoriaAnexosRespostaQuery, useRemoveOuvidoriaAnexoExcluidoMutation } from '../ouvidoriaAnexoApiSlice';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';
import errorFormat from '../../../../../utils/errorFormat';
import { OuvidoriaHistoricoDataTable } from './OuvidoriaHistoricoDataTable';

interface OuvidoriaEditHistoricoProps {
  dados: OuvidoriaList;
  id: string;
}

export const OuvidoriaEditHistorico = ({ dados, id }: OuvidoriaEditHistoricoProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [resposta, setResposta] = useState<string>('');

  const [createOuvidoriaResposta, status] = useAddOuvidoriaRespostaMutation();
  const [createAnexosResposta, statusCreateAnexosResposta] = useAddOuvidoriaAnexosRespostaMutation();
  const [removeAnexosExcluidos, statusRemoveExcluido] = useRemoveOuvidoriaAnexoExcluidoMutation();

  const [ouvidoriaAnexoParaSalvar, setOuvidoriaAnexoParaSalvar] = useState<File[]>([]);
  const [ouvidoriaAnexoSalvo, setOuvidoriaAnexoSalvo] = useState<OuvidoriaAnexo[] | null>(null);

  const [ouvidoriaAnexoParaSalvarResposta, setOuvidoriaAnexoParaSalvarResposta] = useState<File[]>([]);
  const [ouvidoriaAnexoSalvoResposta, setOuvidoriaAnexoSalvoResposta] = useState<OuvidoriaAnexo[] | null>(null);

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setOuvidoriaAnexoParaSalvarResposta(prev => [...prev, ...convertedFiles]);
  };
  const handleOnDeleteParaSalvarResposta = (index: number) => {
    setOuvidoriaAnexoParaSalvarResposta(prev => prev.filter((_, i) => i !== index));
  };
  const handleExcluirTodosAnexos = () => {
    setOuvidoriaAnexoParaSalvarResposta([]);
  };

  function handleOnDeleteSalvo(fileId: string) {
    setOuvidoriaAnexoSalvoResposta(prev => {
      if (prev) {
        return prev.map(arq => (arq.id === fileId ? { ...arq, excluido: true } : arq));
      }
      return null; // ou um array vazio se preferir
    });
  }

  const { data: dataAnexo, isLoading: isLoadingAnexo } = useGetOuvidoriaAnexosQuery({ idOuvidoriaAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexo) {
      setOuvidoriaAnexoSalvo(dataAnexo);
    }
  }, [dataAnexo]);

  const { data: dataAnexoResposta, isLoading: isLoadingAnexoResposta } = useGetOuvidoriaAnexosRespostaQuery({ idOuvidoriaAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexoResposta) {
      setOuvidoriaAnexoSalvoResposta(dataAnexoResposta);
    }
  }, [dataAnexoResposta]);

  const handleGravarAnexos = async () => {
    console.log('Arquivos para salvar:', ouvidoriaAnexoParaSalvarResposta);
    console.log('Ouvidoria:', dados.id);

    if (!dados.id || dados.id.trim() === '') {
      enqueueSnackbar('ID da ouvidoria é obrigatório.', { variant: 'warning' });
      return;
    }

    setLoading(true);

    if (ouvidoriaAnexoParaSalvarResposta.length) {
      const formData = new FormData();
      ouvidoriaAnexoParaSalvarResposta.forEach(file => formData.append('imagens', file));
      formData.append('ouvidoriaID', dados.id);
      await createAnexosResposta(formData);
    }

    if (ouvidoriaAnexoSalvoResposta && ouvidoriaAnexoSalvoResposta?.length) {
      let ouvidoriaAnexoSalvoExcluido: { idAnexo: string }[];

      ouvidoriaAnexoSalvoExcluido = ouvidoriaAnexoSalvoResposta.filter(it => it.excluido === true).map(it => ({ idAnexo: it.id }));

      if (ouvidoriaAnexoSalvoExcluido.length) {
        const formData = new FormData();
        formData.append('ouvidoriaID', dados.id);
        formData.append('anexosExcluidos', JSON.stringify(ouvidoriaAnexoSalvoExcluido));
        await removeAnexosExcluidos(formData);
      }
    }

    handleExcluirTodosAnexos();
    //navigate(configSiteUrls.SITE_OUVIDORIA_T);

    setLoading(false);
  };

  async function handleSubmit() {
    if (!resposta || resposta.trim() === '') {
      enqueueSnackbar('O campo Resposta é obrigatório.', { variant: 'warning' });
      return;
    }

    const parms: OuvidoriaRespostaDTO = {
      id: dados.id || '',
      resposta: resposta.trim()
    };

    setLoading(true);
    const result: any = await createOuvidoriaResposta(parms);
    const dataOuvidoria = result?.data;
    const idOuvidoria = dataOuvidoria?.id;
    setLoading(false);
  }
  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      setResposta('');
      // navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <Paper
      sx={{
        width: '100%',
        p: { xs: 2, sm: 3 },
        mx: 'auto',
        maxWidth: {
          xs: '100%',
          sm: '600px',
          md: '800px',
          lg: '1000px',
          xl: '1200px'
        }
      }}
    >
      {!dados.id ? (
        <Typography variant="body1" sx={{ mb: 2 }}>
          A solicitação que você está tentando acessar não foi encontrada. Verifique se o link está correto ou entre em contato com o suporte para obter assistência.
        </Typography>
      ) : (
        <>
          {/* Andamento / Resposta */}
          <Card
            elevation={3}
            sx={{
              borderRadius: 3,
              bgcolor: '#fafafa',
              mb: 3
            }}
          >
            <Accordion>
              <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="andamento-content" id="andamento-header">
                <Typography color="secondary" variant="body1" fontWeight="bold">
                  Andamentos / Respostas Anteriores
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Paper sx={{ width: '100%', padding: '12px' }}>
                  <OuvidoriaHistoricoDataTable id={id} />
                </Paper>
              </AccordionDetails>
            </Accordion>
          </Card>

          {/* Andamento / Resposta */}
          <Card
            elevation={3}
            sx={{
              borderRadius: 3,
              bgcolor: '#fafafa',
              mb: 3
            }}
          >
            <Accordion>
              <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="andamento-content" id="andamento-header">
                <Typography color="secondary" variant="body1" fontWeight="bold">
                  Adicionar Andamento / Resposta
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <FormControl fullWidth>
                  <TextField
                    required
                    label="Adicionar Andamento / Resposta"
                    name="resposta"
                    onChange={e => setResposta(e.target.value)}
                    size="small"
                    multiline
                    rows={4}
                    inputProps={{ maxLength: 5000 }}
                    value={resposta}
                  />

                  <FormHelperText>{resposta?.length ?? 0}/5000 caracteres</FormHelperText>
                </FormControl>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2,
                    mt: 3
                  }}
                >
                  <Button type="button" variant="contained" color="secondary" onClick={handleSubmit}>
                    Gravar Andamento
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
          </Card>

          {/* Anexos */}
          <Card
            elevation={3}
            sx={{
              borderRadius: 3,
              bgcolor: '#fafafa',
              mb: 3
            }}
          >
            <Accordion>
              <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="anexos-content" id="anexos-header">
                <Typography color="secondary" variant="body1" fontWeight="bold">
                  Anexos
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <GeralAnexosUpload
                  arquivosSalvos={ouvidoriaAnexoSalvoResposta ?? null}
                  arquivosParaSalvar={ouvidoriaAnexoParaSalvarResposta}
                  onFileChange={handleFileAnexoChange}
                  onDeleteParaSalvar={handleOnDeleteParaSalvarResposta}
                  onDeleteAll={handleExcluirTodosAnexos}
                  onDeleteSalvo={handleOnDeleteSalvo}
                  tipo="OUVIDORIA"
                />

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2,
                    mt: 3
                  }}
                >
                  <Button type="button" variant="contained" color="secondary" onClick={handleGravarAnexos}>
                    Gravar Anexos / Alteração
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 2,
                m: 3
              }}
            >
              <Button variant="outlined" onClick={() => navigate(configSiteUrls.SITE_OUVIDORIA_LIST)}>
                Voltar
              </Button>
            </Box>
          </Card>
        </>
      )}
    </Paper>
  );
};
